module.exports = __webpack_public_path__ + "images/icon-android-app.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icon-android-app.png
// module id = 840
// module chunks = 106